export default {
    language: "English",
    bgColor: {
        black: "Black",
        blue: "Blue"
    },    
    Menu: {
        home: "Home",
        taskManage: "Task",
        deviceManage: "Tracker",
        groupManage: "Group",
        fileMenu: "File",
        userManage: "User",
    },
    Home: {
        logout: "Sign Out",
        summary: "Company Dashboard",
        deviceTotal: "Tracker",
        taskTotal: "Task",
        configFileTotal: "Config File",
        groupTotal: "Group",
        userTotal: "User",        
        quickApp: "Shortcut",
        userCreate: "Add User",
        deviceCreate: "Add Tracker",
        fileCreate: "Add File",
        groupCreate: "Create Group",
        deviceMove: "Move Tracker",
        taskCreate: "Create Task",
        deviceState: "Tracker",
        inactiveDevice: "01.Inactive",
        freeDevice: "02.Free",
        pendingDevice: "03.Pending",
        firmwareState: "Firmware",
        firmwaretotal: "Total",
        firmwareToday: "Today",
        firmwareYtday: "Yesterday",
        searchMore: "More",
        noMore: "No more",        
        taskStateTitle: "Task batch status",
        searchDetail: "Learn more",
        taskNum: "No.",
        taskName: "Task name",
        taskType: "Task type",
        taskCode: "Task code",
        taskState: "Task status",
        completeTotal: "Complete|Total",
        taskCreateTime: "Created on",
        taskCreatePerson: "Created by",
        baseInfo: "Basic information",
        changePass: "Change Password",
        oldPass: "Old Password",
        newPass: "New Password",
        confirmPass: "Confirm Password",
        oldPassInput: "Please enter old password",
        newPassInput: "Please enter new password",
        confirmPassInput: "Please enter the new password again",        
    },    
    Query: {
        inputQuery: "Query",
        queryTaskHolder: "Task Name",
        queryTaskType: "Task Type",
        queryDeviceHolder: "Name/Model/IMEI/Series/File",
        queryGroupHolder: "Group name",
        queryFileHolder: "File Name",
        queryFileSource: "Source",
        queryFileType: "File Type",
        queryUserHolder: "Account/Email",        
        selectPlaceHolder: "All",
        company: "Company",
        group: "Group",
        createTime: "Created on",
        startTime: "Start date",
        endTime: "End date",        
        queryBtn: "Query",
        resetBtn: "Reset",
        noticePlaceHolder: "Notification title",
        noticePublish: "Published",
        noticeUnpublish: "Unpublished",
        expandSearch: "Collapse",
        collapseSearch: "Collapse",
        queryMoveDeviceHolder: "Name/Model/IMEI",
    },
    Button: {
        export: "Export",
        create: "Create",
        batchCreate: "Batch Create",
        delete: "Delete",
        submit: "Submit",
        back: "Back",
        edit: "Edit",
        move: "Move",
        createGroup: "Create Group",      
        confirm: "Confirm",
        cancel: "Cancel",
        publish: "Publish",
        next: "Next",
        backUpload: "Back to upload",
        finish: "Finished",
        removeButton: "Remove from group",
        addButton: "Move to target group",
        save: "Save",
        view: "View",
        selectFile: "Select File",
        upload: "Upload",
        stop: "Cancel",
        changePass: "Change Password"

    },
    Export: {
        dataTitle: "Data",
        task: "task",
        device: "device",
        group: "group",
        file: "file",
        user: "user"        
    },
    Table: {
        operation: "Operation"
    },
    TaskManage: {
        id: "ID",
        taskName: "Task name",
        taskState: "Task status",
        taskType: "Task type",
        imei: "IMEI",
        mode: "Model",
        deviceSeries: "Tracker series",
        company: "Company",
        group: "Group",
        originVer: "Original version",
        targetVer: "Target version",
        connectTime: "Connect time",
        createPerson: "Created by",
        createTime: "Created on",
        updateFirmware: "Upgrade Tracker",
        updateConfig: "Config Tracker",
        receiveConfig: "Config upload",
        receiveLog: "Tracker Log",
        sentTLS: "Send TLS file",
        taskPending: "Pending",
        taskCancel: "Canceled",
        taskFail: "Failed",
        taskError: "Download succecssful but has error",
        taskAssign: "Executing",
        taskDownLoadFile: "Download succecssful but not execute",
        taskExecute: "Executed",
        taskPartFail: "Some terminal tasks fail",
        selectFile: "Select file",
        targetFile: "Target file",
        autoMatch: "Automatic match",
        manuallySelectFile: "Select file"
    },
    DeviceManage: {
        id: "ID",
        deviceName: "Tracker name",
        imei: "IMEI",
        mode: "Model",
        deviceSeries: "Series",
        sn: "S/N",
        configFile: "Config file",
        firmwareVer: "Firmware",
        funcitonVer: "Function",        
        deviceState: "Status",
        connectState: "Connection",
        updateTime: "Updated on",
        createTime: "Created on",
        targetFile: "Target file",
        company: "Company",
        group: "Group",
        securityFile: "Secure file version",
        ip: "Domain/IP",
        port: "Port",
        cntFOTAfrequency: "Connect FOTA Manager frequency(min)",
        cntFOTAfunciton: "Connect FOTA Manager function",
        alarmClock: "Alarm clock",
        status_initial: "Initial",        
        status_inactive: "Inactive",
        status_free: "Free",
        status_pending: "Pending",
        status_working: "Working",
        min: "min",
        bestVer: "Best Version",
        task: "Task",
        fotaConnectParam: "FOTA connection parameters",
        settings: "Settings",
        onFOTA: "On",
        offFOTA: "Off",
        notSupport: "Not supported",
        downloadTemplate: "Download template",
        uploadFile: "Upload file",
        downloadImportTemplate: "Download device creation template",
        uploadExcelFile: "Upload Excel file",
        onlySupportXlsXlsx: "Only xlsx format is supported",
        createTemplate: "BatchDeviceCreationTemplate",
        uploarFail: "Creation failed",
        tipFileLarge: "File size cannot exceed 20MB",
        tipSelectFile: "Please select a file",
        uploadSuccess: "Device created successfully",
        tip: "Only xlsx files can be uploaded, and the size must not exceed 20MB"
    },
    GroupManage: {
        id: "ID",
        groupName: "Group Name",
        company: "Company",
        firmwareFile: "Firmware file",
        configFile: "Configuration file",
        createTime: "Created on", 
        deviceSeries: "Series",
        mode: "Type",
        deviceState: "Status",
        fmWareVerStart: "From firmware version",
        fmWareVerEnd: "To firmware version",
        imei: "IMEI",
        deviceName: "Tracker name",
        removeDevice: "Remove from group",
        addDevice: "Move to target group",
        selectCompany: "Please select company",
        selectGroup: "Please select group",
        selectTargetCompany: "Please select target company",
        selectTargetGroup: "Please select target group",    
    },
    FileMenu: {
        id: "ID",
        describe: "Source",
        file: "File",
        type: "Type",
        createTime: "Created on",
        fileType: "File type",
        configFile: "Configuration file",
        otaFile: "OTA file",
        uploadTitle: "Upload parameter configuration file",
        uploadTip: "The file suffix name must be .mop",  
        inputUpload: "Enter information and upload the file",
        executeAdd: "Start to add",
        completeAdd: "Adding Completed",
        importable: "Number of files imported this time",
        notImport: "Number of files that cannot be imported this time",
        addSuccess: "Adding succeeded",
        fromDevice: "From Tracker",
        fromFile: "From File",        
    },
    UserManage: {
        id: "ID",
        userName: "Account",
        userEmail: "Email",
        company: "Company",
        createTime: "Created on",
        validUntil: "Valid until",
        enabled: "Enabled",
        userPass: "Password",
        contact: "Contact",
        phone: "Phone number",
        remark: "Remarks",
        taskPer: {
            manage: "Task Management",
            create: "Create Task",
            edit: "Edit Task",
            delete: "Delete Task"            
        },
        devicePer: {
            manage: "Tracker Management",
            import: " Batch Import",
            create: "Create Tracker",
            edit: "Edit Tracker",
            move: "Move Tracker",
            delete: "Delete Tracker",
        },
        groupPer: {
            manage: "Group Management",
            create: "Create Group",
            edit: "Edit Group",
            move: "Move Group",
            delete: "Delete Group",         
        },
        filePer: {
            manage: "File Menu Management",
            create: "Create File",
            edit: "Edit File",
            delete: "Delete File"            
        },
        userPer: {
            manage: "User Management",
            create: "Create User",
            edit: "Edit User",
            delete: "Delete User"            
        },
        noticePer: {
            manage: "Message Management",
            create: "Create Message",
            edit: "Edit Message",
            delete: "Delete Message",
            view: "View Message"            
        },        
    },
    NoticeManage: {
        noticeCenter: "Notice Center",
        receiveSetting: "Receive settings",
        totalNotice: "Total",
        productNotice: "Product",
        securityNotice: "Safety",
        seviceNotice: "Service",
        receiveTitle: "Notification receiving settings",
        settingMess: "It is recommended that you should enable receiving to prevent missing messages from causing loss.",
        systemNotice: "System notification",
        productUpNotice: "Product Upgrade notification",
        firmwareUpNotice: "Firmware Upgrade notification",
        fileUpNotice: "File Upgrade notification",
        functionUpNotice: "Function Upgrade notification",
        securityUpNotice: "Safety message notification",
        seviceUpNotice: "Service message notification",
        id: "ID",
        noticeTitle: "Title",
        updateTime: "Modified on",
        publisher: "Publisher",
        noticeType: "Type",
        noticeState: "Status",
        noticeColumn: "Message type",
        noticeReceiver: "Receiver",
        noticeContent: "Content",
        noticeWay: "Reminder method",
        noticePlatform: "Internal message",
        noticeEmail: "Email",
        createColumn: "Add message type",
        columnName: "Message type name",
        columnDescrip: "Message type description"        
    },    
    Rules: {
        require: "Required",
        IMEI: "Please enter correct IMEI",
        userName: "Please enter the numbers and letters which contain 3–20 characters",
        userPass: "Please enter the numbers, letters, and special characters which contain 6–20 characters",
        userEmail: "Please enter correct email address",
        phone: "Please enter correct phone number",
        sn: "Please enter correct S/N",
        name: "Please enter the numbers and letters which contain 2–20 characters.",
        inconsistent: "The passwords entered twice are inconsistent",
        firmwareVer: "Please enter correct firmware version",
        configFile: "Please enter correct configuration file version",        
    },
    Message: {
        reqError: "Please contact the administrator",
        tip: "Tip",
        confirmDelete: "Are you sure you want to delete it?",
        delete: "Deletion succeeded",
        deleteFail: "Deletion failed",
        selectDeleteItem: "Please select the item to be deleted",
        success: "Submission succeeded",
        select: "Please select",
        selectTime: "Select time",
        confirmPublish: "Are you sure you want to publish?",
        publish: "Published succeeded",
        selectPublishItem: "Please select the item to be published",     
        edit: "Modification succeeded",
        editFail: "Modification failed",
        operate: "Operation succeeded",
        operateFail: "Operation failed",
        selectItem: "Please select at least one item",
        confirmRemove: "Are you sure you want to remove it from this group?",
        confirmAddGroup: "Confirm to move to",
        selectDevice: "Please select a tracker",
        selectTargetFile: "Please select a target file",
        confirmCancel: "Are you sure you want to cancel?",
        cancel: "Cancel succeeded",
        loginAgain: "No operation for a long time. Please log in to the system again.",
        fileError: "Upload failed, please check the file",
        noPermission: "No operation permission",
        reLogin: "After switching the language, re-log in to the system.",
        cfmSendFOTAParam: "If the FOTA connection parameters are modified incorrectly, the tracker cannot work properly. Are you sure you want to continue?",
        passwordMess: "The old password is incorrect"
    },
    CreatePage: {
        baseInfo: "Basic information",
        filter: "Filter condition",
        baseInfoFilter: "Filter basic information",
        taskDetail: "Task Details",
        paramSetting: "FOTA connection parameter settings",
        createTask: "Create Task",
        editTask: "Edit Task",
        createDevice: "Create Tracker",
        editDevice: "Edit Tracker",
        createGroup: "Create Group",
        editGroup: "Edit Group",
        createFile: "Create File",
        editFile: "Edit File",
        createUser: "Create User",
        editUser: "Edit User",
        permission: "Permission Settings",
        backButton: "Back",
        createNotice: "Create Notification",
        editNotice: "Edit Notification",
        moveDevice: "Move Tracker"        
    },
    LoginPage: {
        login: "Sign In",
        account: "Account",
        password: "Password",
        forgetPassword: "Forget password?",
        policy: "By using FOTA Manager, you agree with",
        policyLink: "privacy policy",
        forgetPassTop: "Forgot your password?Please enter your registered Account below to receive password reset instruction. The password will be sent to the bound mailbox.",
        forgetPassBtm: "Do you remember your password?",
        send: "Send reset link",
        loginSuccess: "Login succeeded",
        loginFail: "Login failed",
        sendSuccess: "Sending succeeded",
        sendFail: "Sending failed",   
        invalidUser: "Invalid User ID"
    },
    Policy: {
        title: "Privacy Policy",
        time: "2022-09-01",
        content1: 'Meitrack ("we") recognizes the importance of privacy and confidentiality of personal information. When you are using our services and/or products, we may collect and use your personal information. Meitrack Privacy Policy ("Privacy Policy") is meant to help you understand how we collect, use, and save your information when you are using our services and/or products, and how you can access, query, update, delete, and protect your information.',
        content2: "This Privacy Policy will help you understand the following:",
        content3: "1. How we collect and use your personal information",
        content4: "2. How we use cookies and similar technologies",
        content5: "3. How we protect your personal information",
        content6: "4. How do you manage your personal information",
        content7: "5. How we protect the information about minors",
        content8: "6. Notices and revisions",
        content9: "7. Contact us",
        content10: "This Privacy Policy applies to Meitrack FOTA Manager and various business functions provided by this service (hereinafter collectively referred to as “Services and/or Products”). You acknowledge that you have read and fully understood this Privacy Policy before using our Services and/or Products, and that you may make appropriate choices in accordance with the terms in this Privacy Policy. In this Privacy Policy, we try to use concise terms and provide related links for further clarification, so that you can better understand them. If you use or continue to use our Services and/or Products after the effective date of each amendment (informed in a timely manner), you will be conclusively deemed to have accepted this Privacy Policy (including the amended version) and to have expressly consented to us collecting, using, saving, and sharing your related information in accordance with the terms of this Privacy Policy.",
        content11: "This Privacy Policy applies only if you use our products and services provided by Meitrack FOTA Manager. If there is a separate privacy policy about one product we provide, or there are special terms in the corresponding user service agreement, the separate privacy policy about the product shall prevail. If the content is not covered by the separate privacy policy and user service agreement, this Privacy Policy shall prevail."
    }    


}